import { _ as _Symbol } from './_Symbol.js';
import './_baseGetTag.js';

var Symbol = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined;
    symbolProto ? symbolProto.toString : undefined;
